module.exports = __webpack_public_path__ + "static/intro_bg-73dc2b05432c59beed0552e6a06641be.png";